import { createGrid, themeQuartz } from 'ag-grid-community'
import { hideElement, setElementHtml } from '../../../../../helpers/generic-js/dom.js'
import { makeColumnDefs } from './make-column-defs.js'
import { addListeners } from './add-listeners.js'
import { ascending } from 'd3'

export function showTenantsGrid (params) {
  const { containerElementId, browserAppAccount } = params
  console.log('showTenantsGrid', params)

  const containerElement = setElementHtml(containerElementId, '')
  if (!containerElement) return

  if (!params.xeroTokenTenants || params.xeroTokenTenants.length === 0) {
    hideElement(containerElementId)
    return
  }

  params.xeroTokenTenants.sort((a, b) => ascending(a.tenantName, b.tenantName))

  const gridOptions = {
    rowData: params.xeroTokenTenants,
    columnDefs: makeColumnDefs(browserAppAccount),
    theme: themeQuartz
  }
  console.log('gridOptions', gridOptions)

  containerElement.classList.add('height-100')
  setGridHeight(containerElement, params.xeroTokenTenants.length, 10)

  const gridApi = createGrid(containerElement, gridOptions)
  console.log('gridApi', gridApi)

  addListeners(containerElement, params.callbacks, browserAppAccount, params.tokenSetInfo)
}

function setGridHeight (gridContainerElement, numberOfRows, maxRows = 10) {
  const gridHeaderHeight = 49 // Header 49 + Filter row 48 + Border 1
  const gridRowHeight = 42
  const gridBufferHeight = 2
  const height = Math.min(maxRows, numberOfRows) * gridRowHeight + gridHeaderHeight + gridBufferHeight
  gridContainerElement.setAttribute('style', `height: ${height}px;`)
}
